module.exports = __webpack_public_path__ + "static/img/background-login.5b9fa45.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/background-login.jpg
// module id = 98nQ
// module chunks = 3